import { render, staticRenderFns } from "./AchievementsSection.vue?vue&type=template&id=21a5d598&scoped=true&"
import script from "./AchievementsSection.vue?vue&type=script&lang=js&"
export * from "./AchievementsSection.vue?vue&type=script&lang=js&"
import style0 from "./AchievementsSection.vue?vue&type=style&index=0&id=21a5d598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5d598",
  null
  
)

export default component.exports